const setPassword = {
  confirmationError: 'Ihr Account konnte nicht verifiziert werden.',
  confirmationSuccessful: 'Ihr Account wurde verifiziert!',
  title: 'Passwort festlegen',
  description: 'Geben Sie hier Ihr neues Passwort ein. Wir fragen nach diesem Passwort, wenn Sie sich erneut anmelden.',
  repeatPassword: 'Neues Passwort bestätigen',
  changePasswordAction: 'Passwort ändern',
}

export default setPassword
